import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 14px;
  max-width: 520px;
  margin: 0 auto;
  padding: 80px var(--gutter);
  text-align: center;
  animation: fadeUp 0.5s var(--ease);

  .glyph {
    font-family: var(--font-display);
    font-style: italic;
    font-weight: 800;
    font-size: clamp(88px, 18vw, 160px);
    line-height: 1;
    letter-spacing: -0.05em;
    color: var(--accent);
  }

  h2 {
    font-size: clamp(26px, 4vw, 36px);
  }

  p {
    color: var(--ink-2);
    margin-bottom: 10px;
  }
`;
